// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"370":"fa0a6e14","9085":"1b4abbdb"}[chunkId] || chunkId) + "." + {"370":"3585e07135f892b0","4841":"2235191ec89e9fc7","9085":"e106f55b63a82c5e","9810":"e35480958b86fea5","9908":"48aa71af91b1899d"}[chunkId] + ".js";
};